/* @flow */
import * as React from "react";
import ScrollableDiv from "nx-components/ScrollableDiv";
import ScrollShadow from "nexia_mobile/components/Scrollable/ScrollShadow";

// Page does not make its children scrollable by default because
// the children of Page need to be able to render `position: absolute`
// content (eg. FooterBar), and iOS has some long-standing bugs where absolutely
// positioned content within a scrollable container judders around,
// gets rendered completely wrong, doesn't get rendered... you name it.
//
// No other browser seems to have this issue. If you set
// `-webkit-overflow-scrolling: auto` on iOS, then everything works right,
// but you lose all momentum scrolling.
//
// The workaround is to not put absolutely positioned content within a
// scrollable container. Therefore, Page isn't scrollable by default.
//
// However, because it is very common to want to create Pages with
// scrollable content, this ScrollableArea component is provided; if you do
// the following:
//
// <Page>
//   <ScrollableArea>
//     {/* Your Stuff Goes Here */}
//   </ScrollableArea>
// </Page>
//
// You will probably get the behavior you want.
//
// If you need to make any absolutely positioned content in your Page,
// it *must not* be a child of your ScrollableArea (should be a sibling, etc).
type Props = {
  ignoreShadowSafeArea?: boolean,
  style?: Object,
  children?: React.Node,
  captureRef?: (?HTMLElement) => void,
};

type State = {
  div: ?HTMLDivElement,
};

export default class ScrollableArea extends React.Component<Props, State> {
  state = {
    div: null,
  };

  render() {
    const {
      children,
      style,
      captureRef,
      ignoreShadowSafeArea,
      ...otherProps
    } = this.props;
    const { div } = this.state;

    return (
      <React.Fragment>
        <ScrollShadow target={div} ignoreSafeArea={ignoreShadowSafeArea} />
        <ScrollableDiv
          style={{
            flex: "1 1 auto",
            ...style,
          }}
          captureRef={(el) => {
            this.setState({ div: el });
            if (captureRef != null) {
              captureRef(el);
            }
          }}
          {...otherProps}
        >
          {children}
        </ScrollableDiv>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Scrollable/ScrollableArea.jsx